export const employeeStatusList = [
    { name : 'Active', value : 1}, 
    {name : 'inactive', value : '2'}
]
export const gpsTrackingList = [
    { label : 'Enable', value : 1 },
    { label : 'Disable', value : 0 }
]